import getProjectActivity from "./getProjectActivity";
import createProjectActivity from "./createProjectActivity";
import updateProjectActivity from "./updateProjectActivity";
import deleteProjectActivity from "./deleteProjectActivity";

import getProjectActivities from "./getProjectActivities";

export { getProjectActivity, createProjectActivity, updateProjectActivity, deleteProjectActivity, getProjectActivities };

export default { getProjectActivity, createProjectActivity, updateProjectActivity, deleteProjectActivity, getProjectActivities };